// Estados de una orden de servicio tecnico, en el orden en que avanza (ver
// ServiceOrderStatus::FLOW en la API): la solicitud llega "pendiente", pasa a "contacto" al
// escribirle al cliente por WhatsApp, "recibido" cuando el equipo llega al taller, "en
// proceso" durante la reparacion y "entregado" al terminar.
export const SERVICE_ORDER_STEPS = [
  { key: 'pendiente', label: 'Pendiente' },
  { key: 'contacto', label: 'Contacto' },
  { key: 'recibido', label: 'Recibido' },
  { key: 'en_proceso', label: 'En proceso' },
  { key: 'entregado', label: 'Entregado' },
];

export const SERVICE_ORDER_STATUS_COLORS = {
  pendiente: 'error',
  contacto: 'secondary',
  recibido: 'info',
  en_proceso: 'warning',
  entregado: 'success',
};

export const serviceOrderStatusLabel = (name) =>
  SERVICE_ORDER_STEPS.find((step) => step.key === name)?.label || name || '—';
